// Define your user roles
export const USER_ROLES = {
  GlobalUserAdmin: "Super Admin",
  UserAdmin: "Admin",
  Viewer: "User",
  Accountant: "Accountant",
  DeviceManager: "Device Manager",
  CampaignsManager: "Campaign Manager",
  POSManager: "Pos Manager",
};
